import { Group, Image, Text, UnstyledButton } from "@mantine/core";

export interface ProductSelectorProduct {
    id?: string | null;
    name?: string | null;
    thumbnailImage?: { src?: string | null } | null;
}

export interface ProductSelectorProps {
    products: ProductSelectorProduct[];
    value?: string | null;
    onChange: (id: string) => void;
}

// Product chooser shown as small thumbnail + name cards (the active one highlighted),
// driving the per-product section.
export const ProductSelector = ({ products, value, onChange }: ProductSelectorProps) => (
    <Group spacing="sm">
        {products.map((product, index) => {
            const id = product?.id ?? String(index);
            const active = id === value;
            return (
                <UnstyledButton key={id} onClick={() => onChange(id)}>
                    <Group
                        spacing={10}
                        noWrap
                        sx={(theme) => ({
                            padding: 6,
                            paddingRight: 16,
                            borderRadius: 12,
                            border: `2px solid ${active ? theme.colors.orange[6] : theme.colors.gray[3]}`,
                            background: active ? theme.fn.rgba(theme.colors.orange[6], 0.06) : "#fff",
                            transition: "border-color 120ms ease, background 120ms ease",
                        })}
                    >
                        {product?.thumbnailImage?.src && (
                            <Image
                                src={product.thumbnailImage.src}
                                width={52}
                                height={38}
                                radius="sm"
                                fit="cover"
                            />
                        )}
                        <Text size="sm" weight={active ? 700 : 600} color={active ? "#0F1B3D" : "#39435A"}>
                            {product?.name}
                        </Text>
                    </Group>
                </UnstyledButton>
            );
        })}
    </Group>
);
